import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'E-commerce',
        projectDesc: 'E-commerce for clothing, with a unique QR code for each client, printed on each clothes, which allows the wearer an innovative way of sharing data such as their social networks, for example, by scan the QR.',
        tags: ['Javascript', 'React', 'MongoDB', 'Material UI'],
        code: 'https://github.com/victorherrera95/scaneaMe/tree/main',
        demo: 'https://scaneame.vercel.app/',
        image: three
    },
    {
        id: 2,
        projectName: `SPA Dog's`,
        projectDesc: 'SPA where you can see different breeds of dogs along with relevant information about them using an external api, and from this: *Search Breeds by name *Filter/sort them',
        tags: ['Javascript', 'React', 'Redux', 'Node.js'],
        code: 'https://github.com/victorherrera95/deploy',
        demo: 'https://deploy-three-sigma.vercel.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Flutter Bank',
        projectDesc: 'Small banking app made with material ui and flutter',
        tags: ['Flutter', 'Material Ui'],
        code: '',
        demo: 'https://res.cloudinary.com/dzdnfbynr/video/upload/v1675199650/Android_Emulator_-_Pixel_XL_API_32_5554_2023-01-27_17-17-26_noxfzg.mp4',
        image: one
    },
    /* {
        id: 4,
        projectName: 'Android Patient Tracker',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['Flutter', 'Firebase'],
        code: '',
        demo: '',
        image: four
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: '',
        demo: '',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: '',
        demo: '',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: '',
        demo: '',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: '',
        demo: '',
        image: eight
    },*/
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/